export default __webpack_public_path__ + "static/media/mars_texture.bb07b073.jpg";